import { API_BASE } from '@/app/config';

export type AnalyticsData = Record<string, undefined | string | boolean | number>; // flat JSON

export interface FetchAnalyticsParams {
  meeting_hash: string;
  metrics: AnalyticsData;
}

export default async function fetchAnalytics(params: FetchAnalyticsParams) {
  const response = await fetch(`${API_BASE}/meeting_metrics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  // fetch only rejects when the request never completed, so a 404 for a meeting
  // that no longer exists would otherwise arrive as a success and reset the
  // caller's failure count. Anything that stops reporting has to be able to see
  // a refusal.
  if (!response.ok) {
    throw new Error(`Failed to report call metrics: ${response.status} ${response.statusText}`);
  }
}
